import styled, { css } from 'styled-components';
import {
	Form, ErrorMessage
} from 'formik';
import { fadeInAndUp } from '../keyframes/fades';

export const StyledForm = styled(Form)`
`;

export const StyledInput = styled.input`
	display: flex;
	align-items: center;
	width: 100%;
	height: 5rem;
	margin-top: 1.4rem;
	margin-bottom: 4.5rem;
	border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
	font-family: ${({ theme }) => theme.fonts.fontFamily};
	font-size: 1.8rem;
	line-height: 5rem;
	transition: border-color 200ms ease;

	${({ active }) => active && css`
		border-color: ${({ theme }) => theme.colors.borderDark};
	`}
`;

export const StyledSelect = styled.select`
	display: flex;
	align-items: center;
	width: 100%;
	height: 5rem;
	margin-top: 1.4rem;
	margin-bottom: 4.5rem;
	border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
	font-family: ${({ theme }) => theme.fonts.fontFamily};
	font-size: 1.8rem;
	line-height: 5rem;
	transition: border-color 200ms ease;

	${({ active }) => active && css`
		border-color: ${({ theme }) => theme.colors.borderDark};
	`}
`;

const errorMessageStyles = css`
	font-size: 1.4rem;
	color: ${({ theme }) => theme.colors.warning};
	opacity: 0;
	animation: ${fadeInAndUp} 350ms ease forwards;
`;

export const StyledErrorMessage = styled(ErrorMessage)`
	position: absolute;
	left: 0;
	bottom: -3.2rem;
	${errorMessageStyles};
`;

export const StyledErrorMessageBlock = styled.div`
	${errorMessageStyles};
`;

export const StyledInfoMessage = styled.p`
	margin-bottom: 1rem;
	font-size: 1.4rem;
	color: ${({ theme }) => theme.colors.grayDarker2};
`;

export const StyledLabel = styled.label`
	position: absolute;
	top: 1.6rem; left: 0;
	font-size: 1.6rem;
	line-height: 1;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.black};
	transition: transform 200ms ease, font-size 250ms ease;
	pointer-events: none;

	${({ active }) => active && css`
		transform: translate3d(0, -3rem, 0);
		font-size: 1.4rem;
	`}
`;

export const StyledFieldWrapper = styled.div`
	position: relative;
`;
